import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';


import Vue from 'vue'

const getDefaultStateForBoms = () => {
    return {
        is_created:null,
        is_deleted:null,
        bom_components:[]
    }
}

// state
const state = getDefaultStateForBoms()

// getters
const getters = {}

// mutations
const mutations = {
    RESET_STATE_FOR_BOMS (state) {
        Object.assign(state, getDefaultStateForBoms())
    },
    SET_IS_CREATED(state, data){
        state.is_created = data
    },
    SET_IS_DELETED(state, data){
        state.is_deleted = data
    },
    FETCH_BOM_COMPONENTS(state, data){
        data.forEach(function (element) {
            element.uom = element.uom_code
        });
        state.bom_components = data
    }
}

// actions
const actions = {
    resetState({ commit }, payload) {
        commit("RESET_STATE_FOR_BOMS")
    },
    fetchComponents({ commit }, data) {
        return axios.post(apiRoutes['GET_BOM_COMPONENTS'], data, authHeader())
            .then(response => {
              if(response.data.code == 1){
                commit('FETCH_BOM_COMPONENTS', response.data.data)
              } else {
                commit('FETCH_BOM_COMPONENTS', [])
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
    },
    async create({ commit, dispatch }, data) {
      await axios
          .post(apiRoutes['CREATE_BOM'], data, authHeader())
          .then(function (response) {
            if(response.data.code == 1)
            {
                let id  = response.data.data.id
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: "Product code has been created",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })

                  commit("SET_IS_CREATED", 1)
                }
            else
            {
                let errors = response.data.data.errors

                if(Array.isArray(errors))
                {
                  let msg = errors.join("\n")

                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: msg,
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
                }


            }

          })
          .catch((error) => {
              // alert(error)
              // console.log(error.response)

              if (error.response) {
                  //alert(error.response.data.message)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.message,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
              }
              else
              {
                  //console.log("Problem submitting New Post", error);
                  Vue.notify({
                    group: 'notify',
                    type: 'error',
                    text: "Problem Creating BOM",
                    max: 5,
                    duration: 5000,
                    speed: 300
                })
              }
          });
    },
    async delete({ commit, dispatch }, data) {
        await axios
            .post(apiRoutes['DELETE_BOM'], data, authHeader())
            .then(function (response) {
              if(response.data.code == 1)
              {
                  let id  = response.data.data
                  Vue.notify({
                      group: 'notify',
                      type: 'success',
                      text: "Product BOM has been deleted",
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                 commit("SET_IS_DELETED", 1)
  
              }
              else
              {
                  let errors = response.data.data.errors
  
                  if(Array.isArray(errors))
                  {
                    console.log(errors)
                    let msg = errors.join("\n")
  
                    Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: msg,
                      max: 5,
                      duration: 5000,
                      speed: 300
                  })
                  }
  
  
              }
  
            })
            .catch((error) => {
                // alert(error)
                // console.log(error.response)
  
                if (error.response) {
                    //alert(error.response.data.message)
                    Vue.notify({
                        group: 'notify',
                        type: 'error',
                        text: error.response.data.message,
                        max: 5,
                        duration: 5000,
                        speed: 300
                    })
                }
                else
                {
                    //console.log("Problem submitting New Post", error);
                    alert("Problem Creating Bom")
                }
            });
      }
}

export {
    state,
    getters,
    actions,
    mutations
}
